module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "summary-card-container",
    style: ({
      borderLeft: ("4px solid " + _vm.color)
    }),
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "icon-container",
    style: ({
      backgroundColor: _vm.color + '20'
    })
  }, [_c('i', {
    class: _vm.icon,
    style: ({
      color: _vm.color
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [(_vm.animate) ? _c('count-to', {
    key: _vm.valueKey,
    attrs: {
      "end-val": _vm.numericValue,
      "duration": 1500,
      "decimals": _vm.isMoney ? 2 : 0
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.formattedValue))]), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.unit))])], 1), _vm._v(" "), (_vm.showCompare) ? _c('div', {
    staticClass: "compare-container"
  }, [_c('div', {
    staticClass: "compare-header"
  }, [(_vm.compareLabel) ? _c('span', {
    staticClass: "compare-time"
  }, [_vm._v(_vm._s(_vm.compareLabel))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "compare-value"
  }, [_c('span', {
    staticClass: "compare-label"
  }, [_vm._v("对比值:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formattedCompareValue) + " " + _vm._s(_vm.unit))])])]), _vm._v(" "), _c('div', {
    staticClass: "compare-trend",
    class: _vm.trendClass
  }, [_c('i', {
    class: _vm.trendIcon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.trendText))])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2492d32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/utils/SummaryCard.vue
// module id = 1031
// module chunks = 3